export enum Feature {
  ASSESSMENT_CREATION = "ASSESSMENT_CREATION",
  VIRTUAL_CONSULTATION = "VIRTUAL_CONSULTATION",
  USER_BRANDING = "USER_BRANDING",
  PATIENT_PORTAL = "PATIENT_PORTAL",
  MONITORING = "MONITORING",
}

export const getFeatureI18nKey = function (feature: Feature) {
  switch (feature) {
    case Feature.ASSESSMENT_CREATION:
      return "Feature.AssessmentCreation";
    case Feature.USER_BRANDING:
      return "Feature.Branding";
    case Feature.VIRTUAL_CONSULTATION:
      return "Feature.VirtualConsultation";
    case Feature.PATIENT_PORTAL:
      return "Feature.PatientPortal";
    case Feature.MONITORING:
      return "Feature.Monitoring";
  }
};
